module.exports = __webpack_public_path__ + "img/location-light.0624309a.svg";